import * as R from "ramda";
const constrainDimensionValues = (dimension, contentConstraints, accessorName) => {
  const dimensionConstraints = R.prop(dimension.id, contentConstraints);
  const isNotConstrained = R.isNil(dimensionConstraints);
  const indexedConstraints = isNotConstrained ? null : R.indexBy(R.identity, dimensionConstraints);
  return R.pipe(
    R.over(
      R.lensProp("values"),
      R.map(
        (val) => R.assoc(
          accessorName,
          isNotConstrained || R.has(val.id, indexedConstraints),
          val
        )
      )
    ),
    R.assoc(accessorName, isNotConstrained || !R.isEmpty(dimensionConstraints))
  )(dimension);
};
const constrainDimensions = (dimensions, contentConstraints, accessorName = "hasData") => {
  return R.map(
    (dimension) => constrainDimensionValues(dimension, contentConstraints, accessorName),
    dimensions
  );
};
export {
  constrainDimensions
};
